export default "__VITE_ASSET__BBqVSg_a__"